/**
 * CSV cell for the browser-side exports (Members, Users, Group, Audit log).
 *
 * Formula injection (TW-232): a value starting with = + - @ (or a tab / carriage
 * return) is evaluated as a formula when the file is opened in Excel or Sheets, so it
 * gets a leading apostrophe, the same rule as csv_formula_guard() on the server.
 * Then RFC 4180 quoting: wrap in quotes when the value has a comma, quote or line break.
 */
export function csvCell(field: unknown): string {
  if (field === null || field === undefined) return '';
  let str = String(field);
  if (str !== '' && '=+-@\t\r'.includes(str[0])) {
    str = `'${str}`;
  }
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}
